<template>
  <div>
    <HeadInfoSimple title="电影" />
    <RelativeSimple />
    <Like />
    <Gotop />
    <Rec />
    <Ob />
  </div>
</template>

<script>
import Gotop from '../common/components/Gotop.vue';
import pageExpose from '../common/mixins/pageExpose';
import HeadInfoSimple from './components/HeadInfoSimple.vue';
import Like from './components/Like.vue';
import Ob from './components/ObserveModule.vue';
import Rec from './components/Rec.vue';
import RelativeSimple from './components/RelativeSimple.vue';

export default {
  components: {
    HeadInfoSimple,
    RelativeSimple,
    Like,
    Gotop,
    Rec,
    Ob,
  },
  mixins: [pageExpose],
  asyncData({ context, store, route }) {
    return store
      .dispatch('detail/prefetchMovieSimpleData', { context, route })
      .catch(err => console.log('[DETAIL_MOVIE_SIMPLE_PREFETCH_ERROR]', err));
  },
};
</script>
